import { Action, CommonActions } from './common-actions';
import { tassign } from 'tassign';
import { Common, initialCommon } from './common-state.model';

/**
* CommonReducer Will excecute the according triggered in the dispatcher
* @param state Store model
* @param action The action that will affect the store
**/
export const CommonReducer = function (state: Common = initialCommon, action: Action): Common {
  switch (action.type) {
    case CommonActions.SET_ERROR_CODE:
      return tassign(state, {
        errorCode: action.payload.errorCode
      });
    case CommonActions.SET_TABLE_DATA:
      return tassign(state, {
        tableColumns: action.payload.tableColumns,
        tableDataSource: action.payload.tableDataSource
      });
    case CommonActions.SET_STEP:
      return tassign(state, {
        step: action.payload.step,
      });
    case CommonActions.SET_GETRESPONSE:
      return tassign(state, {
        getResponse: action.payload.getResponse,
      });
    case CommonActions.SET_FAILEDRECORDS:
      return tassign(state, {
        getFailedRecords: action.payload.getFailedRecords,
      });
    case CommonActions.SET_SHOW_RESULTS:
      return tassign(state, {
        showResults: action.payload.showResults
      });
    case CommonActions.SET_PROFILE:
      return tassign(state, {
        profile: action.payload.profile
      });
    default:
      return state;
  }
};


